import React, { useContext, useEffect, useState } from "react";
import {createPortal} from 'react-dom';
import { useForm, FormProvider } from 'react-hook-form';
import themeMaker, {bssMakeStyles}  from '../../lib/theming';
import Wrapper from '../Wrapper';
import { calcolaPreventivi } from '../../api/estimates';
import FrammentoRiepilogo, { getNextUrl, nextUrlByStep } from "./frammenti/FrammentoRiepilogo";
import FrammentoFiltri from "./frammenti/FrammentoFiltri";
import FrammentoPrezzi from "./frammenti/FrammentoPrezzi";
import FrammentoSubmit from './frammenti/FrammentoSubmit';
import useBSSLogger from "../../hooks/useBSSLogger";

const {logger} = useBSSLogger();

import { Box, Card, Container, Grid, Paper } from '@mui/material';
import { makeStyles } from "@mui/styles";

import BSSPreventivoContext from "../../contexts/BSSPreventivoContext";
import DefaultLoadingComponent from "../form/DefaultLoadingComponent";
import { convertiFormRequestCalcola, DefaultSubmitErrorHandler } from "./Preventivo";
import BSSForm from "../form/BSSForm";
import BSSDataContext from "../../contexts/BSSDataContext";


const FormPrezzi = ({destRiepilogo = null, destPrezzi = null, destFiltri = null, defaultValues, daShortcode, aggiornaPreventivoStorage, nextUrl = null, immaginepreventivodefault, ...rest}) => {
    
    const defaultSortClause = {field: "totalprice", dir: "asc"};
    const [clauses, setClauses] = useState({sort: {}, filter: {}})

    const {shadowBody} = useContext(BSSDataContext);
    logger.debug("test shadowbody per FormPrezzi", shadowBody)


    const {preventivi = {}, filtri = [], preventivoStorage} = useContext(BSSPreventivoContext);

    

    const {quotations = []} = preventivi;

    logger.debug("parametri form prezzi", defaultValues)

    const classes = bssMakeStyles();
    const methods = useForm({
        defaultValues,
        reValidateMode: 'onBlur'
    });
    const {handleSubmit, formState, control} = methods;
    

    const onSubmit = async (data) => {
        logger.info("=======> dati form prezzi: ", data);
    
        //logger.info("faccio avanzare il preventivo per: ", datiRequest);

        aggiornaPreventivoStorage({
            ...data,
            preventivi,
            step: 3,
        })

        const eventoPreventivatore = new CustomEvent("spedizioniweb2_step_2", {
            detail: {//@todo definire dati da passare all'evento
                data,
                quotations,
                preventivoStorage
            }
        });
        document.dispatchEvent(eventoPreventivatore);

        location.href = getNextUrl(nextUrl, 3, null)
        
    }
    
    const props = {destRiepilogo, destPrezzi, destFiltri};
    const dests = ["Riepilogo", "Prezzi", "Filtri"];

    const usePortals = dests.reduce((obj, dest) => {
        const selector = props[`dest${dest}`];
        const destel = document.querySelector(`#${selector}`);
        const esito = (selector !== null && destel !== null) ? destel : false;
        logger.finest({dest, selector, destel, esito})
        return {
            ...obj,
            [dest]: esito 
        }
    }, {})

    const fragmentDefualtProps = {
        methods,
        classes,
        aggiornaPreventivoStorage,
        onSubmit,
        clauses,
        setClauses,
        immaginepreventivodefault
    }
    
    
    return (
        <>
            <FormProvider {...methods}>
                <BSSForm onSubmit={handleSubmit(onSubmit, DefaultSubmitErrorHandler)}>                    
                    {/* <Paper elevation={3} className={`${classes.rounded10} ${classes.container}`}>                         */}

                        <Grid container >
                            <>  
                                {(usePortals["Riepilogo"] !== false)?
                                    createPortal(
                                        <Wrapper inPortal>
                                            <FrammentoRiepilogo {...fragmentDefualtProps} />                                        
                                        </Wrapper>,                                    
                                        usePortals["Riepilogo"]
                                    )
                                    : 
                                    <Box px={1} mb={3} width={1}>
                                        <Card>
                                            <FrammentoRiepilogo {...fragmentDefualtProps} />
                                        </Card>
                                    </Box>

                                    
                                }
                            </>

                            {quotations.length ? (
                                <>
                                    <>
                                        {(usePortals["Filtri"] !== false) &&
                                            createPortal(
                                                <Wrapper inPortal>
                                                    <FrammentoFiltri inPortal {...fragmentDefualtProps} daShortcode={daShortcode} />   
                                                </Wrapper>,  
                                                usePortals["Filtri"]
                                            )                                    
                                        }
                                    </>
                                    
                                    <>
                                        {(usePortals["Filtri"] === false)?
                                            (
                                            
                                                <>
                                                    {(
                                                        <Grid item xs={12} lg={3}>
                                                            <Box pl={1} pr={{xs: 3, sm: 3, md: 3}} mb={3}>
                                                                <FrammentoFiltri {...fragmentDefualtProps} daShortcode={daShortcode} />                          
                                                            </Box>    
                                                        </Grid>
                                                    )}
                                                    
                                                    <Grid item xs={12} lg={9}>
                                                        <FrammentoPrezzi {...fragmentDefualtProps} daShortcode={daShortcode} />                                        
                                                    </Grid>
                                                
                                                    
                                                </>
                                            )
                                            : (
                                                <FrammentoPrezzi {...fragmentDefualtProps} daShortcode={daShortcode} />
                                            )
                                        }
                                    </>                                    
                                </>
                            ) : (
                                <DefaultLoadingComponent />
                            )}
                                                                                                                                            
                        </Grid>
                    {/* </Paper>         */}
                </BSSForm>
            </FormProvider>

        </>
    )
}

export default FormPrezzi